export const updateStoreValueWithParamValue = (
  storeValue: string | null,
  storeSetter: (val: string) => void,
  paramValue: string | null
) => {
  if (paramValue && paramValue !== storeValue) {
    storeSetter(paramValue);
  }
};
